// extracted by mini-css-extract-plugin
export var button = "universalMenuItem-module--button--cbebd";
export var charcoal = "universalMenuItem-module--charcoal--d0027";
export var cotton = "universalMenuItem-module--cotton--4f86b";
export var description = "universalMenuItem-module--description--057a9";
export var featured = "universalMenuItem-module--featured--be476";
export var icon = "universalMenuItem-module--icon--58e6d";
export var iconAndLabelContainer = "universalMenuItem-module--iconAndLabelContainer--ee29a";
export var image = "universalMenuItem-module--image--3209e";
export var imageContainer = "universalMenuItem-module--imageContainer--4f7d3";
export var isBanner = "universalMenuItem-module--isBanner--1968c";
export var trailingMark = "universalMenuItem-module--trailingMark--dc2f1";
export var universalMenuItem = "universalMenuItem-module--universalMenuItem--06da1";
export var visualList = "universalMenuItem-module--visualList--a9b1b";